export default __webpack_public_path__ + "static/media/tripleBlueCard.5155cb80.png";